import React, { useState, useEffect } from "react";
import { Button, Row, Col } from 'react-bootstrap'
import AuthService from "../controllers/AuthService";
import UserService from "../controllers/UserService";

const CardOnlineActivity = props => {

    const [items, setItems] = useState([]);
    const [studentDone, setStudentDone] = useState('d-none');
    const [studentNotDone, setStudentNotDone] = useState('d-none');
    const [studentAnswerDone, setStudentAnswerDone] = useState(false);

    useEffect(() => {
        const name = AuthService.getUserFullName();
        const currentUser = AuthService.getCurrentUser();
      
        UserService.getActivities({
            'status': 'RUNNING',
            'roomId': AuthService.getCurrentUser() && AuthService.getCurrentUser().room ? AuthService.getCurrentUser().room.id : '',
            'domain': AuthService.getCurrentUser().domain.name 
        }).then((res) => {
            const items = []
            console.log(res)
            
            for (const [index, value] of res.data.data.entries()) {
                if (index > 0) {
                    break
                }
                const dateTemp = new Date(value.createdAt.year+'-'+ (value.createdAt.monthValue < 10 ? "0" + value.createdAt.monthValue : value.createdAt.monthValue)+'-'+ (value.createdAt.dayOfMonth < 10 ? "0" + value.createdAt.dayOfMonth : value.createdAt.dayOfMonth));
                var dateTemp1 = convertDate(dateTemp);
                const temp = {
                    attenders: (value.attenders) ? value.attenders.length : 0,
                    usageCount: value.topic.usageCount,
                    category_name: value.topic.categoryDisplayName,
                    activityId: value.id,
                    topicId: value.topic.id,
                    title: value.topic.title,
                    imageUrl: value.topic.imageUrl,
                    created_at: dateTemp1
                };
                items.push(temp);
            }
            setItems(items)
            // console.log(items)


            UserService.getActivityDetail(res.data.data[0].id).then((res) => {
                console.log('--------------');  
                console.log(res.data.data );               

                UserService.getAnswersByStudentId(res.data.data.id, res.data.data.topic.questions[0].id, currentUser.id).then((res) => {
                    if (res && res.answer) {   
                        setStudentAnswerDone(true)                 
                        setStudentNotDone('d-none');
                        setStudentDone('d-inline');
                    } else {
                        setStudentAnswerDone(false)   
                        setStudentNotDone('d-inline');
                        setStudentDone('d-none');
                    }
                })              
                
            })

        });
    }, [])

    const joinActivity = (activityId) => {
        if (studentAnswerDone) {
            window.location.href = `/activity/summary/${activityId}`
        } else {
            window.location.href = `/activity/live/${activityId}`
        }
    }

    return (
        <div className="active-activity pt-0 mb-3">
            { items.map((item, index) => (
                <Col className="border-radius-125 click-pointer" key={index} onClick={() => joinActivity(item.activityId)} >
                    <Row className="mx-auto my-3 border-sd bg-white border-radius-125">
                        <Col xs={12} lg={4} className="p-0">
                            {/* <img src={item.imageUrl} className="w-100 h-100 card-img-left" /> */}
                            <div className="card-image card-img-left" style={{ "backgroundImage": `url(${item.imageUrl})` }}></div>
                        </Col>
                        <Col xs={12} lg={8} className="py-3 py-md-1 px-4 card-homeroom" style={{ "alignSelf": "center" }}>
                            <Row >
                                <Col xs={12} md={9} style={{ "flex": '1' }}>
                                    <div className="text-left"><h3 className="font-sarabun-bold">{item.title}</h3></div>
                                    <div className="pageview grey-text text-left mt-4">
                                        <span className="font-sarabun-bold">{item.category_name}</span>

                                        {props.hideDate !== '1' && (
                                            <span className="font-sarabun"><br></br>
                                                { item.created_at}</span>
                                        )}
                                        {/* | ถูกใช้งาน : { item.usageCount} ครั้ง */}
                                    </div>
                                </Col>

                                <Col xs={12} md={3} className="px-0 d-none d-md-inline" style={{ "flex": '1' }}>
                                    <Button className={`bluebtn m-auto font-sarabun-bold py-2 ${studentNotDone}`} >ร่วมกิจกรรม</Button>
                                    <div className= {`notBtnBluegrey m-auto font-sarabun-bold py-2 bg-blue-grey ${studentDone}`} ><img className="" width="15" src={`/images/icons/check.png`} style={{"verticalAlign": "middle"}} />  ร่วมกิจกรรมแล้ว</div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} className="pb-4 pt-3 d-inline d-md-none">
                            <Button className={`bluebtn m-auto font-sarabun-bold py-2 ${studentNotDone}`} >ร่วมกิจกรรม</Button>
                            <div className={`notBtnBluegrey m-auto font-sarabun-bold py-2 bg-blue-grey ${studentDone}`} ><img className="" width="15" src={`/images/icons/check.png`} style={{"verticalAlign": "middle"}}/> ร่วมกิจกรรมแล้ว</div>
                        </Col>
                    </Row>
                </Col>
            ))}

        </div>


    )
}


function convertDate(dateTime) {    
    var months_th = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",];
    var temp = dateTime.getFullYear() + 543;
    return dateTime.getDate() + ' ' + months_th[dateTime.getMonth()] + ' ' + temp;  
}
export default CardOnlineActivity


